import { useParams } from 'react-router';
import './Customizer.scss';
import { useVerifyEditableItemQuery } from '../store/apiSlice';
import { Oval } from 'react-loader-spinner';
import EditLabelCustomizer from '../components/customizer/RestoreOrderLabel';

function RestoreOrderLabel() {
  const { itemId } = useParams();
  const { data, isLoading, error } = useVerifyEditableItemQuery(itemId);

  if (isLoading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center h-full w-full">
        <p>Loading your order</p>
        <Oval
          visible={true}
          height={50}
          width={50}
          color="#a99cdf"
          strokeWidth="3"
          strokeWidthSecondary="3"
          secondaryColor="#e2e6ff"
          ariaLabel="oval-loading"
        />
      </div>
    );
  }

  if (error || !data?.valid) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center h-full w-full">
        <p className="text-red-500">Unable to load this order item</p>
      </div>
    );
  }

  return (
    <section className="customizer-page full-width flex flex-col gap-10 items-center pt-5 md:pt-10">
      <div className="flex flex-col gap-5 contained-width">
        <div className="flex flex-col gap-5 items-center">
          <h2 className="text-center">Recreate a label for:<br /> {data.item.title}</h2>
          <p className="text-center text-mid mb-0" style={{ maxWidth: '700px' }}>We've encountered an issue printing your artwork. Please use the customizer below to recreate your item's label.</p>
        </div>
      </div>
      <EditLabelCustomizer orderItem={data} token={itemId} />
    </section>
  );
}

export default RestoreOrderLabel
